import { ContactName, IContactName } from "../ContactName";
import { Customer, ICustomer } from "./Customer";

export class CustomerUser implements ICustomerUser {
    constructor(customerUser: ICustomerUser) {
        this.customerUserId = customerUser?.customerUserId;
        this.email = customerUser?.email;
        this.login = customerUser?.login;
        this.institution = new Customer(customerUser?.institution);
        this.contact = new ContactName(customerUser.contact);
        this.meritItems = customerUser.meritItems;
    }

    customerUserId: string;
    email: string;
    login: string;
    institution: Customer;
    contact: ContactName;
    meritItems: string[];
}

export interface ICustomerUser {
    customerUserId: string;
    email: string;
    login: string;
    institution: ICustomer;
    contact: IContactName;
    meritItems: string[];
}